import { useStore } from '@/core/store';
import { useI18N } from '@/core/shared/localization';
import { isRef } from '@vue/composition-api';

export default function useBookingOnSetup (bookingId, defaultBooking, bookingChanges, preSelected, addBookingStationTime, editBooking, setConflictBooking) {
  const store = useStore();
  const i18n = useI18N();
  const unwrappedPreSelected = (isRef(preSelected)) ? preSelected.value : preSelected;

  function handlePreselected () {
    Object.keys(unwrappedPreSelected).forEach(property => {
      if (property === 'bookingStationTimes') return;
      if (property === 'startTime') editBooking('_startNow', false);
      editBooking(property, unwrappedPreSelected[property]);
    });

    delete bookingChanges.value.bookingStationTimes;
    unwrappedPreSelected.bookingStationTimes.forEach(preSelectedBookingStationTime => {
      const experienceId = (preSelectedBookingStationTime.experience) ? preSelectedBookingStationTime.experience.id : null;
      addBookingStationTime(experienceId, preSelectedBookingStationTime);
    });
  }

  async function handleEditBooking () {
    const booking = await store.dispatch('getBooking', bookingId);
    store.commit('setTitle', i18n.t('Editing') + ' ' + booking.title);
  }

  if (bookingId === 'new') {
    Object.keys(defaultBooking).forEach(property => {
      editBooking(property, defaultBooking[property]);
    });
  } else {
    editBooking('id', bookingId);
  }

  if (unwrappedPreSelected) {
    handlePreselected();
  } else if (bookingId !== 'new') {
    handleEditBooking();
  } else {
    addBookingStationTime();
  }

  setConflictBooking();
}
